import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CalculatedFilterEditNRO = lazy(() =>
  import("@segments/CalculatedFilterEdit").then((module) => ({
    default: module.CalculatedFilterEditNRO,
  }))
);

export const calculatedFiltersEditNRO: NavigationRoutingObject = {
  Component: CalculatedFilterEditNRO,
  componentFeatureFlippers: ["calculated_filters"],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-filters-edit-page-heading", "Edit Calculated Filter"),
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("calculated_filters");
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/calculated_filters/:appGroupId",
};
